var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnlocked1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6655_107632)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6 1C3.243 1 1 3.243 1 6C1 8.757 3.243 11 6 11C8.757 11 11 8.757 11 6C11 3.243 8.757 1 6 1ZM6 0C7.5913 0 9.11742 0.632141 10.2426 1.75736C11.3679 2.88258 12 4.4087 12 6C12 7.5913 11.3679 9.11742 10.2426 10.2426C9.11742 11.3679 7.5913 12 6 12C4.4087 12 2.88258 11.3679 1.75736 10.2426C0.632141 9.11742 0 7.5913 0 6C0 4.4087 0.632141 2.88258 1.75736 1.75736C2.88258 0.632141 4.4087 0 6 0Z",
    fill: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.71442 5.571H5.14342V4.286C5.14342 4.05871 5.23371 3.84073 5.39443 3.68001C5.55515 3.51929 5.77313 3.429 6.00042 3.429C6.22771 3.429 6.44569 3.51929 6.60641 3.68001C6.76713 3.84073 6.85742 4.05871 6.85742 4.286H7.28642C7.29121 4.11417 7.26151 3.94312 7.19906 3.78297C7.13662 3.62281 7.04269 3.4768 6.92285 3.35357C6.80301 3.23034 6.65967 3.13238 6.50132 3.06549C6.34297 2.9986 6.17282 2.96414 6.00092 2.96414C5.82902 2.96414 5.65887 2.9986 5.50052 3.06549C5.34217 3.13238 5.19884 3.23034 5.07899 3.35357C4.95915 3.4768 4.86523 3.62281 4.80278 3.78297C4.74033 3.94312 4.71063 4.11417 4.71542 4.286V5.571H4.28642C4.17264 5.571 4.06353 5.6162 3.98307 5.69665C3.90262 5.7771 3.85742 5.88622 3.85742 6V8.571C3.85742 8.68478 3.90262 8.79389 3.98307 8.87435C4.06353 8.9548 4.17264 9 4.28642 9H7.71442C7.8282 9 7.93732 8.9548 8.01777 8.87435C8.09822 8.79389 8.14342 8.68478 8.14342 8.571V6C8.14342 5.88622 8.09822 5.7771 8.01777 5.69665C7.93732 5.6162 7.8282 5.571 7.71442 5.571Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6655_107632"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnlocked1);
export default __webpack_public_path__ + "static/media/Unlocked1.7875fb31194b60e961ca20ce04aae173.svg";
export { ForwardRef as ReactComponent };